import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import enterprise from './modules/enterprise'
import website from './modules/website'
// import settings from './modules/settings'
import getters from './getters'


Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        enterprise,
        website
    },
    getters
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js